import React, { ReactElement, ReactNode } from 'react';
import { Wrapper } from './style';

type Props = {
  children: ReactNode;
  size?: 'default' | 'large';
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

export const MarketsCount = ({
  children,
  size,
  onClick
}: Props): ReactElement => {
  return (
    <Wrapper
      className="markets__count"
      size={size || 'default'}
      onClick={onClick}
    >
      {children}
    </Wrapper>
  );
};
